import { createSlice } from '@reduxjs/toolkit';
import addFavouriteProductsReducer from './reducer/addFavouriteProductReducer';
import removeFavouriteProductReducer from './reducer/removeFavouriteProductReducer';
import setFavouriteProductsReducer from './reducer/setFavouriteProductsReducer';
import { FavouriteProduct, HighlightCategory, HighlightProduct } from './types';
import setHighlightsReducer from './reducer/setHighlightsReducer';
import setHighlightsCategoriesReducer from './reducer/setHighlightsCategoriesReducer';
import resetHighlightsReducer from './reducer/resetHighlightsReducer';

export const favouriteInitialState: FavouriteState = {
  products: [],
  highlights: [],
  categories: [],
};

export interface FavouriteState {
  products: FavouriteProduct[];
  highlights: HighlightProduct[];
  categories: HighlightCategory[];
}

export const slice = createSlice({
  name: 'price',
  initialState: favouriteInitialState,
  reducers: {
    setFavouriteProductsAction: setFavouriteProductsReducer,
    addFavouriteProductAction: addFavouriteProductsReducer,
    removeFavouriteProductAction: removeFavouriteProductReducer,
    setHighlightsAction: setHighlightsReducer,
    resetHighlightsAction: resetHighlightsReducer,
    setHighlightsCategoriesAction: setHighlightsCategoriesReducer,
  },
});

export const {
  setFavouriteProductsAction,
  addFavouriteProductAction,
  removeFavouriteProductAction,
  setHighlightsAction,
  resetHighlightsAction,
  setHighlightsCategoriesAction,
} = slice.actions;

const favourite = slice.reducer;
export default favourite;
